import React from "react";

const NumberStepper = ({
                           label,
                           value,
                           onChange,
                           min = 0,
                           max,
                           step = 1,
                           ...props
                       }) => {
    const handleDecrement = () => {
        const newValue = Math.max(min, Number(value || 0) - step);
        onChange(newValue);
    };

    const handleIncrement = () => {
        const newValue =
            max !== undefined
                ? Math.min(max, Number(value || 0) + step)
                : Number(value || 0) + step;
        onChange(newValue);
    };

    return (
        <div className="field">
            {label && <label>{label}</label>}

            <style>
                {`
          input[type=number]::-webkit-inner-spin-button,
          input[type=number]::-webkit-outer-spin-button {
            -webkit-appearance: none;
            margin: 0;
          }
          input[type=number] {
            -moz-appearance: textfield;
          }
        `}
            </style>

            <div style={{display: "flex", alignItems: "center", gap: "6px"}}>
                <button
                    type="button"
                    style={{
                        backgroundColor: "#1a4fb7",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        padding: "4px 10px",
                        cursor: "pointer",
                    }}
                    onClick={handleDecrement}
                >
                    –
                </button>
                <input
                    type="number"
                    value={value || ""}
                    onChange={(e) => onChange(e.target.value)}
                    style={{
                        width: "60px",
                        textAlign: "center",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        padding: "4px",
                    }}
                    {...props}
                />
                <button
                    type="button"
                    style={{
                        backgroundColor: "#1a4fb7",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        padding: "4px 10px",
                        cursor: "pointer",
                    }}
                    onClick={handleIncrement}
                >
                    +
                </button>
            </div>
        </div>
    );
};

export default NumberStepper;